module.exports = __webpack_public_path__ + "img/purchases.611b2815.svg";